/**
*功能名称：数据库类型接口
*创 建 人：马少华
*日    期：2022/02/25 10:15:17
*/
import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";
export class ServerFileSheelApi extends DbCenterBaseApi {
    public get ControllerName(): any {
        return 'serverSheel';
    }

    //TiDB/PD/TiKV 扩容
    public scaleOutTiDb(entity:any){
        return this.send(entity,"scaleOutTiDb",Methods.POST);
    }

    //TiDB/PD/TiKV 缩容
    public scaleInTiDb(entity:any){
        return this.send(entity,"scaleInTiDb",Methods.POST);
    }

 
}